import React, {useEffect, useState} from "react";
import {Icon28CupOutline} from "@vkontakte/icons";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {getJoinableTournamentsCount} from "../../services/tournament";
import {parseLaunchParams} from "../../utils/launch_params";

const READY_BADGE_CLASSES = "absolute top-2 right-2 inline-flex min-w-[22px] h-5 items-center justify-center px-1 rounded-full text-[11px] font-semibold bg-yellow-400 text-black border border-yellow-500";

// Баннер, ведущий к отдельной панели турниров, оформленный в стиле остальных карточек.
export default function TournamentBanner() {
    const routeNavigator = useRouteNavigator();
    // Храним количество турниров, доступных для вступления.
    const [joinableCount, setJoinableCount] = useState(0);

    const handleClick = () => routeNavigator.push('/tournaments');

    useEffect(() => {
        // Загружаем количество доступных турниров для бейджа.
        const params = parseLaunchParams();
        if (!params.vk_user_id) {
            setJoinableCount(0);
            return;
        }

        getJoinableTournamentsCount().then(resp => {
            const count = resp.data?.response?.count ?? 0;
            setJoinableCount(Number.isFinite(count) ? count : 0);
        }).catch(err => {
            console.error("tournament banner load error", err);
            setJoinableCount(0);
        });
    }, []);

    return (
        <div className="w-full cursor-pointer" onClick={handleClick}>
            <div className="bg-gray-200 border border-gray-300/50 rounded-xl shadow-sm p-4 space-y-4 relative">
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-yellow-400 text-yellow-800 flex items-center justify-center">
                        <Icon28CupOutline/>
                    </div>
                    <div className={" text-gray-800"}>
                        <p className="text-base font-semibold">Турниры</p>
                        <p className="text-sm">Соревнуйтесь за призы ежедневно и еженедельно</p>
                    </div>
                </div>
                {joinableCount > 0 && (
                    <span className={READY_BADGE_CLASSES}>{joinableCount}</span>
                )}
            </div>
        </div>
    );
}
